import { useState, useEffect } from 'react';

import { config } from 'config';
import { notify } from 'libs/common';
import { user } from 'services/user';
// import { PageAuth } from './pages/page-auth/page-auth';
// import { PageMain } from './pages/page-main/page-main';
import { Loader } from 'components/loader/loader';
import { Router } from './router/router';

export const App = () => {
  const ok = config.network;
  const [checked, setChecked] = useState(ok ? false : true);

  /**
   * check user token
   */
  useEffect(() => {
    if (ok) {
      window.user = user;
      user
        .getInfo()
        .then(() => {
          setChecked(true);
        })
        .catch((error) => {
          notify('Ошибка сети', error);
          setChecked(true);
        });
    }
  }, [ok]);

  if (!checked) {
    return <Loader />;
  }

  const logined = ok ? user.isLoggedIn : false;

  return <Router logined={logined} />; //user.isLoggedIn ? <PageMain /> : <PageAuth />;
};
